module.exports = __webpack_public_path__ + "static/gallery_kerry_5-f313c940e5ed45688e1c7ee681b6fe77.jpg";